//import { TfsContext } from "Presentation/Scripts/TFS/TFS.Host.TfsContext";
/// <amd-module name="Test/StackTraceParser/SourceInfoProviders/TfsVersionControl" />
import { getServiceHostUrl } from "Test/StackTraceParser/Common"
import {
    IFilePathData,
    ILinkedStackTraceInfo,
    IParsedStackTraceInfo,
    ISourceInfoProvider,
    RepositoryTypes
} from "Test/StackTraceParser/Contracts";
import { IVssComponentContext } from "VSS/Platform/Layout";
import { BaseSourceInfoProvider } from "Test/StackTraceParser/SourceInfoProviders/BaseSourceInfoProvider";
import { ITfvcRestClient } from "VC/Common/RestClient/Tfvc";

export class TfsVersionControl extends BaseSourceInfoProvider implements ISourceInfoProvider {

    private tfvcPrefix = "$/";

    constructor(private context: IVssComponentContext, private project: string, private sourceBranch: string) {
        super();
    }

    public getKey() {
        return RepositoryTypes.TfsVersionControl;
    }

    public constructFilePath(parsedStackTraceInfo: IParsedStackTraceInfo[]): Promise<ILinkedStackTraceInfo[]> {
        return new Promise<ILinkedStackTraceInfo[]>((resolve, reject) => {

            // check if there is any full path in stack trace
            parsedStackTraceInfo.forEach(x => {
                if (x.filePathData) {
                    this.shouldGetRootFilesAndFolder = this.shouldGetRootFilesAndFolder || x.filePathData.isFullPath;
                }
            })

            this._getRootFilesAndFolder(this.sourceBranch).then(() => {
                let result = parsedStackTraceInfo.map((parsedInfo) =>
                    this.constructFilePathForEachLine(parsedInfo)
                );

                resolve(result);
            });
        });
    }

    private constructFilePathForEachLine(parsedInfo: IParsedStackTraceInfo): ILinkedStackTraceInfo {
        let linkedStackTraceInfo = {
            stackTrace: parsedInfo.stackTrace
        } as ILinkedStackTraceInfo;

        if (!!parsedInfo.filePathData) {
            if (this.removeSourceDirectoryFromPath(parsedInfo.filePathData)) {
            let fileUrl = this.constructUrl(parsedInfo.filePathData);
            if (!!fileUrl) {
                linkedStackTraceInfo.url = fileUrl;
            }
        }
    }

        return linkedStackTraceInfo;
    }

    // Contruct URL for the file.
    private constructUrl(filePathData: IFilePathData): string {
        const hostUri = getServiceHostUrl(this.context.pageContext);
        if (this.project && this.sourceBranch && hostUri) {
            let filePathUrl = hostUri
                + encodeURIComponent(this.project) + "/_versionControl" + "?path="
                + encodeURIComponent(this.sourceBranch) + "/"
                + encodeURIComponent(filePathData.filePath.split("\\").join("/")) + "&version="
                + "&line=" + encodeURIComponent(filePathData.lineNumber.toString())
                + "&lineEnd=" + encodeURIComponent((filePathData.lineNumber + 1).toString())
                + "&lineStartColumn=" + encodeURIComponent(filePathData.columnNumber.toString())
                + "&lineEndColumn=" + encodeURIComponent(filePathData.columnNumber.toString())
                + "&lineStyle=plain"
                + encodeURIComponent("T") + "&_a=contents";

            return filePathUrl;
        }
        else {
            console.warn(`TfsVersionControl.constructFilePath: Can not create path. Project: ${this.project}, Branch: ${this.sourceBranch}`)
            return "";
        }
    }

    private _getRootFilesAndFolder(branchName: string): Promise<null> {
        return new Promise<null>((resolve, reject) => {
            if (this.shouldGetRootFilesAndFolder && !this.rootFilesAndFolder) {
                let tfvcService = this.context.pageContext.getRestClient<ITfvcRestClient>("ITfvcRestClient");

                tfvcService.getItems(this.project, this.sourceBranch).then((tree) => {
                    if (tree) {
                        this.rootFilesAndFolder = tree.map(x => {
                            if (x.path !== this.sourceBranch) {
                                if (x.path.startsWith(this.sourceBranch)) {

                                    // here x.path is in the form $/branch/foldername and this.sourceBranch is $/branch.
                                    // So to remove extra "/", adding 1.
                                    return x.path.substring(this.sourceBranch.length + 1);
                                }

                                return x.path;
                            }
                        });

                        resolve(null);
                    }
                    resolve(null)
                });
            }
            else {
                resolve(null);
            }
        });
    }
}
